// 消息分析 — M10 已切真后端（/api/messages/keywords + /api/messages/menu/clicks）
// 对应 scraper: mp_msgkeyword + mp_menuclick（M8 之后才会跑）
// 后端 schema: app/schemas/message.py
//   注意:两个端点都返回 { date, items: [...] } 信封,不是裸数组
import { useQuery } from '@tanstack/react-query'
import { get } from '@/lib/api'

export interface MsgKeywordItem {
  keyword: string
  count: number
  ratio: number
  isCustom: boolean
}

export interface MsgKeywordResponse {
  date: string
  items: MsgKeywordItem[]
}

export interface MenuClickItem {
  menuId: string | null
  menuName: string
  clickCount: number
  clickUser: number
  avgPerUser: number
}

export interface MenuClickResponse {
  date: string
  items: MenuClickItem[]
}

export function useMsgKeywords() {
  return useQuery({
    queryKey: ['messages', 'keywords'],
    queryFn: () => get<MsgKeywordResponse>('/messages/keywords'),
  })
}

export function useMenuClicks() {
  return useQuery({
    queryKey: ['messages', 'menu-clicks'],
    queryFn: () => get<MenuClickResponse>('/messages/menu/clicks'),
  })
}
